/* Passive, consent-aware journey measurement; native purchase events stay with Shopify. */
(() => {
  'use strict';
  const version = 'premium-20261021';
  const debug = new URLSearchParams(location.search).get('kimaia_track_debug') === '1';
  function emit(name, properties) {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    const data = {version, page: location.pathname, device: innerWidth < 750 ? 'mobile' : 'desktop', ...properties};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: name, ...data});
    try { Promise.resolve(window.Shopify?.analytics?.publish?.(name, data)).catch(() => {}); } catch (_) {}
    if (window.Shopify?.customerPrivacy?.marketingAllowed?.()) {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', name, data]);
    }
    if (debug) console.info('[KIMAIA conversion]', name, data);
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('a, button');
    if (!event.isTrusted || !button || button.disabled) return;
    const explicit = button.closest('[data-kimaia-conversion]');
    let placement = explicit?.dataset.kimaiaConversion;
    if (!placement && button.matches('.ke-product__action')) placement = 'home-product';
    if (!placement && button.matches('[data-kmsc-cta],#kpAdd,[data-gfo-btn]')) placement = 'product-buy';
    if (!placement && button.closest('.ksa-bar,.kp-sticky')) placement = 'sticky-buy';
    if (!placement && button.closest('.kbv-card') && button.matches('a,button')) placement = 'bundle-card';
    if (!placement) return;
    emit('kimaia:buy_route_clicked', {placement, label: button.textContent.trim().slice(0,100), destination: (button.getAttribute('href') || button.dataset.ksUrl || '').split('?')[0]});
  }, true);
  document.addEventListener('kimaia:cart:changed', event => {
    if (event.detail?.action === 'add') emit('kimaia:cart_add_succeeded', {source: event.detail.source || 'storefront'});
  });
})();
